import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthModule } from "@auth0/auth0-angular";
import { environment as env } from "@environments/environment";
// Modules
import { AppRoutingModule } from "@app/app-routing.module";
import { CoreModule } from "@core/core.module";
import { environment } from "@environments/environment";

// Components
import { AppComponent } from "./app.component";

import { registerLocaleData } from "@angular/common";
import localesAR from "@angular/common/locales/es-AR";
import localesCL from "@angular/common/locales/es-CL";
import localesCO from "@angular/common/locales/es-CO";
import localesCR from "@angular/common/locales/es-CR";
import localesEC from "@angular/common/locales/es-EC";
import localesMX from "@angular/common/locales/es-MX";
import localesPE from "@angular/common/locales/es-PE";
import localesUY from "@angular/common/locales/es-UY";
import localesBR from "@angular/common/locales/pt";
import { COUNTRY_CODE } from "@environments/environment.type";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    AuthModule.forRoot({
      domain: env.auth0.domain,
      clientId: env.auth0.client_id,
      cacheLocation: "localstorage",
      authorizationParams: {
        redirect_uri: `${window.location.origin}/rappi-sync`,
      },
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      registrations.forEach(reg => {
        reg.unregister();
      });
    });

    registerLocaleData(this.getLocale());
  }

  getLocale() {
    switch (environment.code) {
      case COUNTRY_CODE.ar:
        return localesAR;
      case COUNTRY_CODE.br:
        return localesBR;
      case COUNTRY_CODE.cl:
        return localesCL;
      case COUNTRY_CODE.co:
        return localesCO;
      case COUNTRY_CODE.cr:
        return localesCR;
      case COUNTRY_CODE.ec:
        return localesEC;
      case COUNTRY_CODE.mx:
        return localesMX;
      case COUNTRY_CODE.pe:
        return localesPE;
      case COUNTRY_CODE.uy:
        return localesUY;
      default:
        return localesCO;
    }
  }
}
